import { render, staticRenderFns } from "./OrdersByQuarterChart.vue?vue&type=template&id=076e3dfe&scoped=true&"
import script from "./OrdersByQuarterChart.vue?vue&type=script&lang=js&"
export * from "./OrdersByQuarterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e3dfe",
  null
  
)

export default component.exports